"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TermCard = require("./TermCard");
Object.keys(_TermCard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TermCard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TermCard[key];
    }
  });
});